'use strict'
// import '@babel/polyfill'
import ServiceExec from '@/common/utils/ServiceExec'
import { forEach } from 'lodash'

/**
 * 회원공간 관련 API Service
 * @class SignSvc
 */
class SpaceSvc extends ServiceExec {
  /**
   *  회원 홍보관 리스트
   *  @param Authorization {string} Authorization
   *  @param isMine {integer} 내가쓴글(1: 내가쓴글)
   *  @param limit {integer} 10
   *  @param page {integer} 1
   *  @param searchText {string} 검색어
   *  @param searchType {integer} 검색키워드타입(1: 제목, 2: 내용, 3: 제목+내용)
   */
  getListBoxPromotion(params = {}) {
    return this.get(`/api/home/space/getListBoxPromotion`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  회원 홍보관 상세
   *  @param Authorization {string} Authorization
   *  @param promotionNo {integer} promotionNo
   */
  getMapPromotion(params = {}) {
    return this.get(`/api/home/space/getMapPromotion`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  회원 홍보관 등록
   *  @param Authorization {string} Authorization
   *  @param promotionDTO {PromotionDTO} promotionDTO
   */
  postIntPromotion(params = {}) {
    return this.post(`/api/home/space/postIntPromotion`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  회원 게시판 리스트
   *  @param Authorization {string} Authorization
   *  @param isMine {integer} 내가쓴글(1: 내가쓴글)
   *  @param limit {integer} 10
   *  @param page {integer} 1
   *  @param searchText {string} 검색어
   *  @param searchType {integer} 검색키워드타입(1: 제목, 2: 내용, 3: 제목+내용)
   */
  getListBoxBoard(params = {}) {
    return this.get(`/api/home/space/getListBoxBoard`, params).then(
      response => {
        return response.data
      }
    )
  }
  /**
   *  회원 게시판 상세
   *  @param Authorization {string} Authorization
   *  @param boardNo {integer} boardNo
   */
  getMapBoard(params = {}) {
    return this.get(`/api/home/space/getMapBoard`, params).then(response => {
      return response.data
    })
  }

  /**
   *  회원 게시판 등록
   *  @param Authorization {string} Authorization
   *  @param boardDTO {BoardDTO} boardDTO
   */
  postIntBoard(params = {}) {
    return this.post(`/api/home/space/postIntBoard`, params).then(response => {
      return response.data
    })
  }

  /**
   *  회원 게시판 댓글 등록
   *  @param Authorization {string} Authorization
   *  @param boardNo {integer} boardNo
   *  @param reviewContent {string} reviewContent
   */
  postIntReview(params = {}) {
    const formData = new FormData()
    forEach(params, function(value, key) {
      formData.append(key, value)
    })
    return this.multiPost(`/api/home/space/postIntReview`, formData).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  회원 게시판 댓글 리스트
   *  @param Authorization {string} Authorization
   *  @param boardNo {integer} 게시판 no
   *  @param limit {integer} 10
   *  @param page {integer} 1
   */
  getListBoxReview(params = {}) {
    return this.get(`/api/home/space/getListBoxReview`, params).then(
      response => {
        return response.data
      }
    )
  }
}

export default new SpaceSvc()
